import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { Status } from "../../../model/status";
import { Messages } from "../../../model/messages";
import { StatusService } from "../../../services/status.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../../services/navigation.helper";
import { Navigation } from "../../../model/navigation";
import { ActionButtonSubmit } from "../../../model/action-button-submit";

@Component({
    selector: "status-details",
    templateUrl: "./status-details.component.html",
    styleUrls: ["./status-details.component.css"],
})
export class StatusDetailsComponent implements OnInit {
    messages = new BehaviorSubject<Messages>(Messages.EMPTY);
    status = new BehaviorSubject<Status>(new Status(0, "", ""));
    editMode: boolean = false;
    statusForm: FormGroup;
    statusTitle: string = "statusDetails.title.status.details";
    isLoading = false;
    supervisor: boolean = false;
    constructor(
        private statusService: StatusService,
        private auth: AuthService,
        private fb: FormBuilder,
        private router: Router,
        private nav: NavigationHelper
    ) { }

    ngOnInit(): void {
        this.initializeForm();

        if (Navigation.NEW.toString() === this.nav.currentId) {
            this.editMode = true;
            this.statusForm.reset();
            this.statusTitle = "statusDetails.title.new.status";
        }
        this.statusService.selectedStatusObservable.subscribe((selectedStatus) => {
            if (selectedStatus) {
                this.messages.next(Messages.EMPTY);
                this.populateForm(selectedStatus);
            }
        });
        if (
            !(this.statusService.currentStatus && this.statusService.currentStatus.id)
        ) {
            this.statusService.selectFromRouter();
        }
        this.supervisor = this.auth.isSupervisor();
    }

    private initializeForm(): void {
        this.statusForm = this.fb.group({
            name: ["", [Validators.required, Validators.minLength(2)]],
            color: [""],
        });
    }

    private populateForm(status: Status): void {
        this.status.next(status);
        this.statusForm.patchValue({
            id: status.id,
            name: status.name,
            color: status.color,
        });
        this.editMode = status.id === Navigation.NEW;
        this.statusTitle = this.editMode
            ? "statusDetails.title.new.status"
            : "statusDetails.title.status.details";
    }
    toggleEditMode() {
        if (this.editMode) {
            this.editMode = false;
            this.status.next(Status.EMPTY);
            this.statusForm.reset();
            this.messages.next(Messages.EMPTY);
            this.statusTitle = "statusDetails.title.status.details";
        } else {
            this.editMode = true;
        }
    }

    saveStatus(action: ActionButtonSubmit): void {
        this.isLoading = true;

        if (this.statusForm.valid) {
            const token = this.auth.token;
            const id = this.status.value.id;

            const updatedStatus = new Status(
                id === null || id < 1 ? null : id,
                this.statusForm.value.name || "",
                this.statusForm.value.color || ""
            );

            if (updatedStatus.id === null || updatedStatus.id < 1) {
                this.statusService
                    .createStatus(token, updatedStatus)
                    .subscribe((messages) => {
                        this.isLoading = false;
                        this.messages.next(messages);

                        if (messages.hasAnyMessages) {
                            action.result(false);
                        } else {
                            this.updateStatusList(token);
                            this.router.navigate(["status"]);
                            action.result(true);
                        }
                    });
            } else {
                this.statusService.updateStatus(token, updatedStatus).subscribe(
                    (messages) => {
                        this.isLoading = false;
                        this.messages.next(messages);

                        if (messages.hasAnyMessages) {
                            action.result(false);
                        } else {
                            this.updateStatusList(token);
                            this.router.navigate(["status"]);
                            action.result(true);
                        }
                    },
                    (error) => {
                        this.isLoading = false;
                        action.result(false);
                        this.messages.next(
                            Messages.from({ status: ["status.unknown.error", error] })
                        );
                    }
                );
            }
        } else {
            this.isLoading = false;
            action.result(false);

            this.messages.next(Messages.from({ status: ["statusDetails.form.invalid"] }));
        }
    }

    deleteStatus(): void {
        const token = this.auth.token;
        const statusId = this.status.value.id;

        if (statusId != null) {
            this.statusService.deleteStatus(token, statusId).subscribe(
                (response) => {
                    this.messages.next(response);
                    this.updateStatusList(token);
                    this.status.next(Status.EMPTY);
                },
                (error) => {
                    this.messages.next(
                        Messages.from({ status: ["status.delete.failed"] })
                    );
                }
            );
        }
    }
    updateStatusList(token: string): void {
        this.statusService.status(token).subscribe((messages) => {
            const updatedStatus = this.statusService.statusData;
            this.statusService._currentStatus.next(updatedStatus);
        });
    }
    get TRUE(): boolean {
        return true;
    }
    get FALSE(): boolean {
        return false;
    }
    get isSupervisor(): boolean {
        return this.auth.userdata.supervisor;
    }
}
